<template>
    <el-tooltip class="item" :disabled="disabled" effect="dark" :content="address" placement="bottom-start">
        <el-input v-model="address" :placeholder="placeholderinfo ? placeholderinfo: '输入关键字（如小区名称）'" :id="`${pickerInput}`" @change="blurchange" maxlength="100" :show-overflow-tooltip="true" :disabled="disabledType"></el-input>
    </el-tooltip>
</template>

<script>
import {geo, regeo} from '@/api/gaode'
import {getStoreSession} from '@/utils/utils'
export default {
    props: ['comtransmit', 'addressCodeName', 'getDetailAddress','placeholderinfo','disabledType'],
    data() {
        return {
            addressData: '',
            addressArr: '',
            address: '',
            getAddressdata: {
                name: [],
                code: []
            },
            pickerInput: '',
            disabled: true
        }
    },
    mounted() {
        if(this.address !== '') {
            this.disabled = false
        }
        if(this.comtransmit && this.comtransmit.type) {
            this.pickerInput = `${this.comtransmit.type}${this.comtransmit.index}`
        }
        if(this.getDetailAddress && this.getDetailAddress.detailAddress) {
            this.address = this.getDetailAddress.detailAddress
        }
        this.init()
    },
    watch: {
        getDetailAddress(newVal, oldVal) {
            if(this.getDetailAddress !== undefined) {
                if(JSON.stringify(this.addressCodeName) == "{}") {
                    this.address = this.getDetailAddress.detailAddress ? this.getDetailAddress.detailAddress : newVal
                } else {
                    for (var key in this.addressCodeName) {
                        if (this.addressCodeName[key] == null && String(key).indexOf('Name') > 0) {
                            this.addressCodeName[key] = ""
                        }
                    }
                    if(this.getDetailAddress.detailAddress) {
                        this.address = `${this.addressCodeName.provName}${this.addressCodeName.cityName}${this.addressCodeName.areaName}${this.addressCodeName.streetName}${this.getDetailAddress.detailAddress}`
                    } else {
                        this.address = `${this.addressCodeName.provName}${this.addressCodeName.cityName}${this.addressCodeName.areaName}${this.addressCodeName.streetName}`
                    }
                    this.getAddressdata.code = [this.addressCodeName.provCode, this.addressCodeName.cityCode, this.addressCodeName.areaCode, this.addressCodeName.streetCode]
                }
            } else {
                this.address = null
                this.getAddressdata.code = [null, null, null, null]
            }
        }
    },
    methods: {
        init() {
            /***************初始化地图***************/
            let _this = this
            AMapUI.loadUI(['misc/PoiPicker'],function(PoiPicker) {
                let poiPicker = new PoiPicker({
                    input: _this.pickerInput
                })
                poiPicker.on('poiPicked', function(poiResult) {
                    if(poiResult.item.location !== undefined) {
                        let latlng = `${poiResult.item.location.lng},${poiResult.item.location.lat}`
                        _this.regeo(latlng, 1)
                    }
                });
            })
        },
        // geo(parameters, typeClick) {
        //     /***************地理编码***************/
        //     geo(`address=${parameters}`, (data) => {
        //         if(data.geocodes.length > 0) {
        //             this.regeo(data.geocodes[0].location, typeClick)
        //             this.getAddressData(0)
        //         }
        //     })
        // },
        regeo(parameters, typeClick) {
            /***************逆地理编码***************/
            regeo(`location=${parameters}`, (data) => {
                let addressArr = data.regeocode.addressComponent
                    this.addressData = addressArr.province + addressArr.city + addressArr.district + addressArr.township
                    this.addressArr = addressArr
                this.address = data.regeocode.formatted_address
                this.getAddressData(1)
            })
        },
        getAddressData(type) {
            /* push addressArr to step1 */
            if(type == 0) {
                this.getAddressdata = {
                    names: [null, null, null, null],
                    code: [null, null, null, null]
                }
            } else {
                this.getAddressdata = {
                    names: ["", "", "", ""],
                    code: [`${this.addressArr.towncode.substr(0, 2)}00000000`, `${this.addressArr.towncode.substr(0, 4)}00000000`, `${this.addressArr.adcode}000000`, this.addressArr.towncode],
                    address: this.address
                }
                this.getAddressdata = Object.assign(this.comtransmit, this.getAddressdata)
            }
            console.log(this.getAddressdata);
            this.$emit('addressData', this.getAddressdata)
        },
        blurchange() {
            if(this.address !== '') {
                this.disabled = false
            }
            this.getAddressdata = {
                names: ["", "", "", ""],
                code: [null, null, null, null],
                address: this.address
            }
            if(this.comtransmit) {
                this.getAddressdata = Object.assign(this.comtransmit, this.getAddressdata)
            }
            this.$emit('addressData', this.getAddressdata)
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
